module.exports = __webpack_public_path__ + "img/img7.e19187a4.png";